import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DateTime } from "luxon";
import { useCallback, useEffect, useState } from "react";

// 2022.11. 텍스트 에디터 기능으로 추가 (delta to html)
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';


import {
  axios,
  getBackgroundColor,
  getHoverBackgroundColor,
  topics,
  Transition,
} from "../../commons";

import Page from "../elements/Page";
import ArticleForm from "./ArticleForm";

const ArticleList = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(false);
  const [isShownBackdrop, toggleShownBackdrop] = useState(false);

  // article 목록 조회
  const load = useCallback(async () => {
    toggleShownBackdrop(true);
    try {
      const { data } = await axios.get(`/admin/board/articles`);
      let convertArticles = convertContent(data); // 게시글 내용 변환 (delta로 저장된 내용을 처리하기 위함)
      // setItems(data.articles);
      setItems(convertArticles);
    } catch (err) {
      console.error(err);
    }
    toggleShownBackdrop(false);
  }, []);

  // delta content의 text만 filter해서 가공
  const convertContent = (data) => {
    let articles = [];
    for (let i in data.articles) {
      let article = data.articles[i];
      // 내용이 delta인 경우
      if(article.content.includes('insert')) {
        const content = JSON.parse(article.content);

        // 이미지를 url 초기화 (이미지를 불러올때 gsName이 붙었을 때 html태그에서 오류가 나서 image url은 빈문자열로 초기화)
        for(let i=0; i<content.length; i++) {
          if(content[i].insert.image !== undefined) {
            content[i].insert.image = '';
          }
        }

        // delta를 html태그로 변환
        let cfg = {};
        let converter = new QuillDeltaToHtmlConverter(content, cfg);
        let html = converter.convert(); // html태그로 변환
        let div = document.createElement('div');
        div.innerHTML = `${html}`;
        article['content'] = div.textContent; // div 영역에서 텍스트만 추출
      }
      articles.push(article);
    }
    return articles;
  }

  // 해당 게시글 내용 조회
  const loadItem = useCallback(async (id) => {
    toggleShownBackdrop(true);
    try {
      const { data } = await axios.get(`/admin/board/articles/${id}`); // 해당 건에 서버에 호출

      console.log({ data });

      setEditing({ ...data, id });
    } catch (err) {
      console.error(err);
    }
    toggleShownBackdrop(false);
  }, []);

  // 팝업창 닫혔을 때 실행
  const handleClose = useCallback(
    (isSaved) => {
      if (isSaved === true) {
        load();
      }

      setEditing(false);
    },
    [load]
  );

  useEffect(load, [load]);

  return (
    <>
      <Page
        title="Articles"
        //  display="flex" height="100%"
      >
        <Container
          maxWidth="xl"
          // sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ pb: 5 }} display="flex">
            <Typography variant="h4">Articles</Typography>
            <Button
              variant="contained"
              sx={{ ml: "auto" }}
              onClick={() => {
                setEditing(true);
              }}
            >
              New
            </Button>
          </Box>

          <Box
            flexGrow={1}
            sx={{
              "& .deleted": {
                bgcolor: (theme) =>
                  getBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode
                  ),
                "&:hover": {
                  bgcolor: (theme) =>
                    getHoverBackgroundColor(
                      theme.palette.error.main,
                      theme.palette.mode
                    ),
                },
              },
            }}
          >
            <DataGrid
              autoHeight
              rows={items}
              columns={columns}
              getRowClassName={(params) =>
                `${params.row.deletedAt ? "deleted" : ""}`
              }
              onRowClick={({ id }) => {
                loadItem(id);
              }}
              // pageSize={3}
            />
          </Box>
        </Container>
      </Page>

      <Dialog
        fullScreen
        open={!!editing}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {!!editing && (
          <ArticleForm
            initialValues={editing}
            onStartProcess={() => {
              toggleShownBackdrop(true);
            }}
            onClose={handleClose}
          />
        )}
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isShownBackdrop}
        onClick={() => {
          // toggleShownBackdrop(false);
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ArticleList;

const columns = [
  {
    field: "topic",
    headerName: "Topic",
    width: 150,
    valueFormatter: ({ value }) => topics[value],
  },
  { field: "content", headerName: "Content", flex: 1 },
  { field: "userDisplayName", headerName: "Author", width: 100 },
  {
    field: "createdAt",
    headerName: "Created at",
    width: 180,
    valueFormatter: ({ value }) =>
      DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT),
  },
  {
    field: "files",
    headerName: "첨부파일 갯수",
    width: 120,
    valueFormatter: ({ value }) => (value ? value.length : null),
  },
];
